import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, type Ref, toRefs } from 'vue';
import { Event } from '@/models/Event';
import { instance as api } from '@/helpers/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportdataPanel',
  props: {
    record: null
  },
  setup(__props: any) {

const props = __props as {
    record: Event;
};


const { record } = toRefs(props);

const importdataHtml: Ref<string | null> = ref(null);

const loadImportdataHtml = async () => {
    try {
        const ret = await api().get('/Event/loadImportdataHtml', {
            params: { id: record.value.id },
        });
        if (ret?.data) {
            importdataHtml.value = String(ret.data);
        }
    } catch (e) {
        // pass
    }
};

onMounted(() => {
    loadImportdataHtml();
});

return { __sfc: true,props, record, importdataHtml, loadImportdataHtml }
}

})